import { useAtomValue as t } from "jotai";
import { arrivalDateAtom as m, departureDateAtom as n, totalAdultsAtom as s, totalChildrenAtom as u } from "./index26.mjs";
const A = () => {
  const o = t(m), r = t(n), e = t(s), a = t(u);
  return {
    arrivalDate: o,
    departureDate: r,
    totalGuests: e + a
  };
};
export {
  A as useBookingData
};
